import Vue from 'vue'
import VueRouter from 'vue-router'
import BasicLayout from "@/components/layout/BasicLayout";

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'layout',
        component: BasicLayout,
        redirect: "/home",
        children: [
            {
                path: '/home',
                name: 'Home',
                component: () => import("@/views/home/Index"),
            },
            {
                path: '/casual',
                name: 'Casual',
                component: () => import("@/views/casual/Index"),
            },
            {
                path: '/casual/create',
                name: 'CasualCreate',
                component: () => import("@/views/casual/Create"),
            },
            {
                path: '/record',
                name: 'Record',
                component: () => import("@/views/record/Index"),
            },
            {
                path: '/record/recordmember',
                name: 'RecordMember',
                component: () => import("@/views/record/recordmember"),
            },
            {
                path: '/member',
                name: 'Member',
                component: () => import("@/views/member/Index"),
            },
            {
                path: '/account',
                name: 'Account',
                component: () => import("@/views/account/Index"),
            },
            {
                path: '/customer',
                name: 'Customer',
                component: () => import("@/views/customer/Index"),
            },
            {
                path: '/deplete',
                name: 'deplete',
                component: () => import("@/views/deplete/Index"),
            },
            {
                path: '/promoter',
                name: 'promoter',
                component: () => import("@/views/promoter/Index"),
            },
            {
                path: '/income',
                name: 'income',
                component: () => import("@/views/income/Index"),
            },
            {
                path: '/sendcard',
                name: 'sendcard',
                component: () => import("@/views/sendcard/Index"),
            },
            {
                path: '/orders',
                name: 'orders',
                component: () => import("@/views/orders/Index"),
            },
            {
                path: '/withdraworders',
                name: 'withdraworders',
                component: () => import("@/views/withdraworders/Index"),
            },
            {
                path: '/vip',
                name: 'vip',
                component: () => import("@/views/vip/Index"),
            },
            {
                path: '/vipprotoco',
                name: 'vipprotoco',
                component: () => import("@/views/vipprotoco/Index"),
            },
            {
                path: '/shareapp',
                name: 'shareapp',
                component: () => import("@/views/shareapp/Index"),
            },
            {
                path: '/atm',
                name: 'atm',
                component: () => import("@/views/atm/Index"),
            },
            {
                path: '/setting',
                name: 'Setting',
                component: () => import("@/views/setting/Index"),
            },

            {
                path: '/mall',
                name: 'Mall',
                component: () => import("@/views/mall/Index"),
            }
        ]
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/login/Index')
    }
]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

export default router
